<template>
	<div>
		<div class="search-container">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </div>
    <TableRefresh 
      :state="loading"
      @click.native="reload"
    />
		<v-data-table
			:headers="headers"
			:items="invites"
			:loading="loader"
			:search="search"
			class="elevation-1 admin-table"
		>
			<template v-slot:progress>
				<v-progress-linear color="blue" height="2" indeterminate></v-progress-linear>
			</template>
			<template v-slot:item.role.name="{ item }">
         {{ mapUserRole(item.role.name) }}
      </template>
			<template v-slot:item.group="{ item }">
         {{orgNodes[item.org.nodeId]}}
      </template>
			<template v-slot:item.cancel="{item}">
				<v-icon small icon color="red" class="mr-2" @click="toggleDeletePrompt(item)">mdi-cancel</v-icon>
			</template>
		</v-data-table>

		<Prompt
			:display="deleteInviteConfirm"
			:close-target="'closeDelete'"
			:submit-target="'submitDeleteLog'"
			:title="'Delete Pending Invite'"
			:message="'Are you sure you wish to delete this pending invite?'"
			:state="deleteInviteState" 
			:res="deleteInviteRes"
			@closeDelete="toggleDeletePrompt"
			@submitDeleteLog="cancel"
		/>
	</div>
</template>

<script>

	import { AmplifyEventBus } from "aws-amplify-vue";
	import { ListOrgInvites, DeletePendingInviteByID } from "@/services/API.js";

	import TableRefresh from '@/components/general/TableRefresh.vue';
	import Prompt from '@/components/general/Prompt.vue';

	import { Logger } from "aws-amplify";
	const logger = new Logger("OrgInviteList");

	export default {
		components: {
			TableRefresh,
			Prompt
		},
		props: {
			update: {
				type: Number,
				default: 0
			},
			orgNodeList: {
				type: Array,
				default: () => []
			}
		},
		data: () => ({
			headers: [
				{ text: "Email", value: "email" },
				{ text: "Role", value: "role.name" },
				{ text: "Assigned Group", value: "group" },
				{ text: "Created On", value: "createdOn" },
				{ text: "Cancel Invite", value: "cancel", sortable: false }
			],
			invites: [],
			loader: true,
			noresult: false,
			loading: false,
			search: '',
			deleteInviteConfirm: false,
			deleteInviteState: false,
			deleteInviteRes: null,
			deleteTarget: {}
		}),
		computed: {
			org() {
				if (this.$route.params.name) {
					return this.$route.params.name;
				}
				return null;
			},
			orgNodes () {
				return this.orgNodeList.reduce((set, item) => {
					set[item.value] = item.title
					return set
				}, {})
			}
		},
		watch: {
			update(val) {
				val && this.reload();
			}
		},
		created() {
			this.reload();
		},
		methods: {
			mapUserRole(role) {
				const map = {
					THIRD_PARTY_USER: 'API_USER'
				};

				return Object.hasOwn(map, role) ? map[role] : role;
    },

			toggleDeletePrompt(item) {
				this.deleteLogdeleteInviteStateState = false;
				this.deleteTarget = item;
				this.deleteInviteRes = null
				this.deleteInviteConfirm = !this.deleteInviteConfirm;
			},
			async reload() {
				this.loading = true;
				this.invites = [];

				logger.info('reloading')
				if (this.$route.params.name) {
					// const name = this.$route.params.name.replace(/-/g, " ");
					const res = await ListOrgInvites(this.org);
					logger.info(res);
					this.loading = false;
					this.loader = false;
					if (res && res.Invites.length > 0) {
						this.invites = res.Invites.filter(invite => {
							return invite.expired === "false";
						});
					} else {
						this.loading = false;
						this.noresult = true;
					}
				}
			},
			open(id) {
				if (confirm("Do you really want to cancel this invite?")) {
					this.loading = true;
					this.cancel(id);
				}
			},
			async cancel() {
				const inviteId = this.deleteTarget.inviteId;
				const res = await DeletePendingInviteByID(inviteId);

				if (res) {
					this.invites = this.invites.filter(invite => {
						return invite.id === inviteId;
					});
					this.deleteInviteState = true;
          this.deleteInviteRes = {
            msg: `Invite deleted`,
            code: 'green'
          };
					
					AmplifyEventBus.$emit("snackEvent", {
						color: "success",
						text: `Invite Canceled`
					});
					this.reload();
				}
				else {
					this.deleteInviteState = true;
					this.deleteInviteRes = {
						msg: `An error has occurred`,
						code: 'red'
					};
				}
			}
		}
	};
</script>

<style lang="scss">
	.search-container {
    width: 20em;
    padding-left: 1em;
  }
</style>